import React from 'react';
import { cn } from '../../lib/classNames';

/**
 * Contenitore unico del sito pubblico (10_RESTYLING_SITO_PUBBLICO.md §2.3).
 * max-width 1200px; narrow 760px per testi lunghi.
 */
export function PageContainer({ children, narrow = false, className = '', as: Tag = 'div', ...rest }) {
  return (
    <Tag
      className={cn('vc-container', narrow && 'vc-container--narrow', className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default PageContainer;
